import { FormlyFieldConfig } from "@ngx-formly/core";
import { LinkDownload } from "app/formly/link-download.type";
import { AllegatiBolliAltroStep } from "../../shared/allegati-bolli-altro.step";

export const AllegatiPassoCarraioStep: FormlyFieldConfig[] = [
    {
      "props": { "label": 'ALLEGATI ' },
      "fieldGroup": [
        {
          "key": 'allegati_foto',
          "type": 'mat-upload',
          "props": {
            "label": "FOTO DEL LUOGO",
            "multiple": true,
            "required":true
          },
        },
      ]
    },
  ]

